<template>
  <div class="question-modal">
    <div @click="closeEmoji" class="row mt-3 ">
      <div class="col-md-12 col-sm-12 text-left">
        <label for="question" class="mb-1 input-label bold-text">Subject</label>
        <a-input
          :maxLength="maxQuestion"
          :size="'large'"
          placeholder="Please be Specific and Concise"
          style="background-color: white"
          v-model.lazy="$v.formResponses.question.$model"
        />
        <div class="error-container" v-if="$v.formResponses.question.$error">
          <div class="error-item" v-if="!$v.formResponses.question.required">
            Required
          </div>
        </div>
        <p class="text-right">
          <small class="font-light"
            >Characters remaining:
            {{ maxQuestion - formResponses.question.length }}
          </small>
        </p>
      </div>
      <div class="col-md-12 col-sm-12 text-left">
        <label for="category" class="mb-2 input-label bold-text"
          >Category</label
        >
        <a-select
          :size="'large'"
          class="w-100"
          placeholder="Select Category"
          show-search
          style="width: 120px"
          v-model.lazy="$v.formResponses.category.$model"
        >
          <a-select-option
            :value="category.key_name"
            v-for="category in categories"
            :key="category.id"
            >{{ category.display_name }}</a-select-option
          >
        </a-select>
        <div class="error-container" v-if="$v.formResponses.category.$error">
          <div class="error-item" v-if="!$v.formResponses.category.required">
            Category Required
          </div>
        </div>
      </div>
    </div>
    <div @click="closeEmoji" class="row mt-3 position-relative">
      <div class="col-md-12 col-sm-12 text-left pb-5">
        <label for="description" class="mb-1 input-label bold-text"
          >Question</label
        >
        <!-- <div class="message-input-container">
          <a-textarea
            :value="formResponses.description"
            :maxLength="maxDescription"
            :size="'large'"
            placeholder="Describe your question"
            v-model.lazy="$v.formResponses.description.$model"
          />
        </div> -->
        <div>
          <quillEditor
            v-model="$v.formResponses.description.$model"
            ref="quillEditor"
            :options="editorOption"
            height="400"
          ></quillEditor>
        </div>
        <div
          class="error-container mt-5"
          v-if="$v.formResponses.description.$error"
        >
          <div class="error-item" v-if="!$v.formResponses.description.required">
            Required
          </div>
        </div>
        <!-- <p class="text-right">
          <small class="font-light"
            >Characters remaining:
            {{ maxDescription - formResponses.description.length }}</small
          >
        </p> -->
        <!-- <i
          class="fa fa-camera fa-2x file-icon"
          :style="{ color: getPrimaryColor() + ' !important' }"
        >
          <input
            @change="handlePicUpload"
            class="camera-icon-inp"
            type="file"
            ref="file"
          />
        </i> -->
      </div>
    </div>
    <div @click="closeEmoji" class="mb-3">
      <div class="tags-input">Tags</div>
      <div>
        <a-select
          show-search
          mode="multiple"
          :value="selectedTags"
          placeholder="Search for Tags"
          class="w-100 tag-search"
          :filter-option="false"
          @search="handleSelectTags"
          @change="handleSetTags"
        >
          <a-select-option v-for="d in searchTage" :key="d.id" :value="d.name">
            {{ d.name }}
          </a-select-option>
        </a-select>
      </div>
    </div>
    <div>
      <div v-if="isImageUploading" class="d-flex justify-content-center mt-2">
        <div>
          <div class="spinner-border position-absolute spinner-class"></div>
        </div>
        <div :style="{ 'margin-left': '-33px', 'margin-top': '40px' }">
          Loading image...
        </div>
      </div>
      <div :class="fileList.length ? 'd-none' : ''" />
      <!-- Image Upload -->
      <div class="d-flex flex-wrap display-images ">
        <div
          class="file-images"
          @click="handleChange(i)"
          v-for="(fi, i) in fileList"
          v-bind:key="i"
        >
          <!-- <img
            :width="500"
            :height="300"
            :style="{ ' object-fit': 'cover', background: 'black' }"
            :src="fi.url"
            alt=""
          /> -->
          <img
            :style="{ 'object-fit': 'contain', background: 'black', 'max-height':'500px', 'max-width':'600px' }"
            :src="fi.url"
            alt=""
          />
          <a-icon class="ico-cancel cp" type="close-circle" theme="filled" />
        </div>
      </div>
      <!-- End of Image Upload -->
    </div>
    <hr />
    <div class="sticky-footer">
      <div class="d-flex justify-content-between  question-footer">
        <div class="d-flex">
          <div class=" add-post">Add to your post</div>
          <div>
            <div>
              <div
                class="button-container"
                :style="{ display: 'flex', width: '100%' }"
              >
                <div
                  class="d-flex align-items-center justify-content-end flex-column"
                  ref="emojiPicker"
                >
                  <CustomEmojiPicker
                    :visible="emojiVisible"
                    :handleVisible="handleEmojiVisible"
                    :insert="insert"
                  />Emoji
                </div>
                <div
                  class="d-flex align-items-center flex-column ml-2 position-relative cp"
                >
                  <font-awesome-icon
                    size="2x"
                    :style="{
                      color: getPrimaryColor(),
                      opacity: 1,
                      transform: 'scale(0.8)'
                    }"
                    :icon="['fal', 'camera']"
                  />Image
                  <input
                    class="camera-icon-inp cp"
                    type="file"
                    accept="image/png, image/jpeg, image/gif, image/svg+xml"
                    ref="fileInput"
                    @change="handlePicUpload()"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="post-buttons d-flex ml-4">
          <button
            key="cancel"
            class="ask-button"
            @click="handleShowModal"
            :style="{
              background: '#fff',
              color: '#000',
              padding: '10px 40px',
              'border-radius': '8px',
              border: '1px solid ' + getPrimaryColor(),
              height: '50px'
            }"
            >Cancel</button 
          >
          <a-button
            :loading="loading"
            class="ask-button font-white ml-4 primary-button"
            @click="postQuestion()"
            :style="{ background: getPrimaryColor(), border: '1px solid ' + getPrimaryColor(), padding: '12px 50px' }"
            >Ask</a-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import s3Upload from "../../utilities/imageUploader";
import { RepositoryFactory } from "../../repositories/RepositoryFactory";
import { quillEditor } from "vue-quill-editor";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCamera } from "@fortawesome/pro-light-svg-icons";
import CustomEmojiPicker from "../home/emojiPicker.vue";
library.add(faCamera);
const QARepository = RepositoryFactory.get("qa");
const UserRepository = RepositoryFactory.get("user");
const AppRepository = RepositoryFactory.get("app");
const PostRepository = RepositoryFactory.get("posts");

export default {
  name: "CreateQuestionModal",
  components: {
    quillEditor,
    CustomEmojiPicker
  },
  props: {
    handleShowModal: Function,
    showCongrats: Function
  },
  data() {
    return {
      isImageUploading: false,
      emojiVisible: false,
      uiState: "submit_not_clicked",
      fileList: [],
      previewImage: null,
      previewVisible: false,
      empty: true,
      treatment: null,
      errors: false,
      formResponses: {
        question: "",
        description: "",
        category: undefined,
        question_attach: []
      },
      categories: undefined,
      currentPage: 1,
      limit: 10,
      loading: false,
      appliedFilters: "",
      editorOption: {
        theme: "snow",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"],

            [{ list: "ordered" }, { list: "bullet" }],

            ["clean"]
          ]
        }
      },
      maxQuestion: 140,
      maxDescription: 3000,
      loading: false,
      selectedTags: [],
      searchTage: []
    };
  },
  validations: {
    formResponses: {
      question: {
        required
      },
      description: {
        required
      },
      category: {
        required
      }
    }
  },
  created() {
    this.handleSelectTags('a')
    this.init();
    if (this.$route.params.type === "others") {
      AppRepository.getOtherTreatment(this.$route.params.id)

        .then(res => {
          this.defaultItems(res.data.data.data[0]);
        })
        .catch(err => null);
    } else if (this.$route.params.type === "nonmedicaltreatments") {
      AppRepository.searchNonmedicaltreatments("", this.$route.params.id)
        .then(res => {
          // this.treatments = res.data.data;
          this.defaultItems(res.data.data[0]);
        })
        .catch(err => {
          console.log(err);
        });
    } else {
      AppRepository.getTreatment(this.$route.params.id)

        .then(res => {
          if (res.status === 204) {
            AppRepository.getOtherTreatment(this.$route.params.id)
              .then(res => {
                console.log(res, "res");
                this.defaultItems(res.data.data.data[0]);
              })
              .catch(err => null);
          }
          this.defaultItems(res.data.data.data[0]);
        })
        .catch(err => null);
    }
  },

  methods: {
    fetchPosts(append = false) {
      this.$store.commit("App/setLoading", { data: true });

      PostRepository.getAll(
        this.authUser.user.id,
        this.currentCircle.id,
        this.currentPage,
        this.limit,
        this.appliedFilters,
        this.$store.state.Posts.filterPostKey
      )
        .then(res => {
          this.$store.commit("Posts/setPosts", res.data);
          this.$store.commit("App/setLoading", { data: false });
          console.log(this.currentPage, "after fetch");
        })
        .catch(err => {
          console.log(err);
        });
    },
    defaultItems(data) {
      this.treatment = data;
      this.formResponses.question = `${data.display_name}`;
      this.formResponses.category = "Treatment";
      this.formResponses.description = "";
    },
    insert(emoji) {
      if (
        this.formResponses.description[
          this.formResponses.description.length - 2
        ] === "l"
      ) {
        this.formResponses.description =
          this.formResponses.description.substring(
            0,
            this.formResponses.description.length - 10
          ) +
          emoji +
          this.formResponses.description.substring(
            this.formResponses.description.length - 10
          );
      } else {
        this.formResponses.description =
          this.formResponses.description.substring(
            0,
            this.formResponses.description.length - 4
          ) +
          emoji +
          this.formResponses.description.substring(
            this.formResponses.description.length - 4
          );
      }
      this.handleEmojiVisible();
    },

    handleSelectTags(value) {
      console.log(value, "search tags");
      PostRepository.getTags(value).then(res => {
        this.searchTage = res.data.data;
        // console.log(this.searchTage, "searaskjcbasc");
      });
    },

    handleSetTags(value) {
      console.log(value);
      this.selectedTags = value;
    },

    init() {
      QARepository.getQuestionCategories()
        .then(res => {
          let isOthers = null;
          this.categories = res.data.data.filter((ele, index) => {
            if (ele.display_name === "Other") {
              isOthers = ele;
            }
            return ele.display_name !== "Other";
          });
          this.categories.push(isOthers);
        })
        .catch(err => null);
    },

    /**
     * Handle Question category
     */
    handleCategory(value) {
      this.formResponses.category = value;
      this.$v.formResponses.category.$touch();
    },
    /**
     * Get the location of the user using Geolocation
     */
    getLocation() {
      return new Promise(function(resolve, reject) {
        navigator.geolocation.getCurrentPosition(
          function(pos) {
            const latitude = pos.coords.latitude;
            const longitude = pos.coords.longitude;
            resolve({ latitude, longitude });
          },
          function(error) {
            reject("unable to fetch location");
          }
        );
        reject("unable to fetch location");
      });
    },

    /**
     * Handle image Upload
     */
    async handleChange(data) {
      this.fileList.length === 1
        ? (this.fileList = [])
        : this.fileList.splice(data.file.uid - 1, 1);
      this.formResponses.question_attach.splice(data.file.uid - 1, 1);
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },
    async handlePicUpload() {
      if (this.fileList.length) {
        this.$notification.error({
          message: "Error",
          description: "Cannot add more than one image"
          });
      } else {
        this.isImageUploading = true;
        const file = this.$refs.fileInput.files[0];

        try {
          if (!file.type.includes("image")){
            this.$notification.error({
              message: "Error",
              description: "Please select only image"
            });
            this.isImageUploading = false;
            return;
          }
          const urlPayload = { file_name: [file.name] };
          const urlData = await UserRepository.getPresignedUrl(urlPayload);
          const fileName = urlData.data.data.filename[0];
          await s3Upload(urlData.data.data.url[0], file);
          this.formResponses.question_attach.push(fileName);
          this.isImageUploading = false;
          const fileListData = {
            uid: this.formResponses.question_attach.length,
            name: file.name,
            status: "done",
            url: urlData.data.data.preview_url
          };
          this.fileList.push(fileListData);
        } catch (err) {
          this.isImageUploading = false;
        }
      }
    },

    /**
     * Post a Question
     */
    async postQuestion() {
      this.$v.$touch();
      let loc;
      try {
        loc = await this.getLocation();
      } catch (error) {
        loc = {
          lat: null,
          lon: null
        };
      }

      const payload = {
        user_circle: this.currentCircle.id,
        category:
          this.formResponses.category.toLowerCase() === "all"
            ? ""
            : this.formResponses.category,
        question: this.formResponses.question,
        question_description: this.formResponses.description,
        question_attach:
          this.formResponses.question_attach.length > 0
            ? this.formResponses.question_attach
            : null,
        question_location: "location",
        latlong:
          loc.lat && loc.lon ? { latitude: loc.lat, longitude: loc.lon } : null,
        // latlong: {
        //   latitude: loc.lat,
        //   longitude: loc.lon
        // },
        user: this.authUser.user.id,
        tags: this.selectedTags
      };

      this.empty = !this.$v.formResponses.$anyDirty;
      this.errors = this.$v.formResponses.$anyError;
      this.uiState = "submit_clicked";
      const headers = {
        Authorization: `Bearer ${this.authUser.user.token}`
      };

      if (this.errors === false && this.empty === false) {
        this.loading = true;
        this.$http
          .post(`${process.env.BASE_API_URL}/askquestions/`, payload, {
            headers
          })
          .then(res => {
            this.emojiVisible = false;
            this.formResponses.question = "";
            this.formResponses.description = "";
            this.formResponses.category = "";
            this.formResponses.question_attach = [];
            this.selectedTags = [];
            this.handleShowModal();
            this.fetchPosts();
            this.loading = false;
            this.$notification.success({
              message: "Success",
              description: "Your question has been posted."
            });
            // this.$router.push({ name: "QASearch" });
            if (!this.authUser.user.first_post) {
              this.showCongrats();
              this.authUser.user.first_post = true;
            }
          })
          .catch(err => {
            this.loading = false;
          })
          .catch(err => {
            this.loading = false;
          });
      }
      this.loading = false;
    },
    closeEmoji(e) {
      this.emojiVisible = false;
    },
    handleEmojiVisible() {
      this.emojiVisible = !this.emojiVisible;
    }
  }
};
</script>

<style scoped lang="scss">
.camera-icon-inp {
  opacity: 0;
  position: absolute;
  left: 0;
  top: 0;
  width: 35px;

  height: 40px;
  cursor: pointer;
}
.file-icon {
  position: absolute;
  bottom: 50px;
  right: 30px;
}
.ask-button {
  border-radius: 8px;
  padding: 12px 48px;
  font-size: 15px;
}
.message-input-container {
  display: block;
  border: 1px solid #e2e2e2;
  background: #f7f7f7;
  border-radius: 10px;
  padding: 10px 20px;

  .fa-camera {
    width: 35px;
    height: 35px;
    position: relative;
    vertical-align: text-top;
    cursor: pointer;
  }
  .camera-icon-inp {
    opacity: 0;
    position: absolute;
    right: -40px;
    top: -40px;
    width: 40px;
    // height: 40px;
    cursor: pointer;
    z-index: 10;
  }

  textarea {
    border: transparent;
    border-radius: 0;
    border-bottom: 1px solid #e2e2e2;

    &:focus {
      box-shadow: 0 0 transparent;
    }
  }

  .button-container {
    padding: 5px 0 0 0;
    text-align: right;
    display: flex;
    width: 100%;
    align-items: center;
    height: 40px;

    input {
      height: 25px;
    }
  }
}
.flexing {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  height: auto;
}
.add-post {
  font-size: 14px;
  color: #4d4d4d;
  line-height: 14px;
  font-weight: 700;
  display: flex;
  align-items: center;
  padding-right: 5px;
}
.quill-editor {
  height: 100px !important ;
}
.tags-input {
  margin-top: 40px;
  width: 100%;
  font-weight: 700;
  margin-bottom: 5px;
}
.file-images {
  display: flex;
  padding: 10px;
  position: relative;
  .ico-cancel {
    position: absolute;
    font-size: 20px;
    color: red !important;
    top: 0;
    left: 0;
    border-radius: 10px;
    background: #fff;
  }
}
.display-images {
  max-height: 500px;
  // overflow-y: scroll;
}

.question-footer {
  @media screen and (max-width: 900px) {
    flex-direction: column;
    position: sticky;
    bottom: 0;
    width: 100vw;
    background: #ffffff;
    padding: 10px;
  }
}
.sticky-footer {
  @media screen and (max-width: 900px) {
    // background: aqua;
    position: relative;
    width: 100vw;
    left: calc(-44vw + 43%);
    bottom: 0;
    display: initial;
  }
}
em {
  font-style: italic !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Modals/CreateQuestionModal.vue